import { pick } from "lodash";
import SumoLogger, { SumoLoggerOptions } from "sumo-logger";
import { User } from "types";
import { queryClient } from "../api/queryClient";
import { config } from "../config";
import { AccountState } from "../hooks/useAccount";
import { isXolaAdmin } from "../models/User";

const { endpoint } = config.sumologic;
const options: SumoLoggerOptions = {
    endpoint,
    interval: 5000, // Send messages in batches every 5 seconds
    batchSize: 100_000, // Or when total log length reaches 100k characters
    sendErrors: true,
    sourceName: "X2 Seller",
};

const logger = endpoint ? new SumoLogger(options) : console;

export const log = (message: string, data: any = {}, flushLogs = false) => {
    const account = queryClient.getQueryData<AccountState>("account");
    const user = account ? account.user : ({} as unknown as User);

    const payload: any = {
        message,
        data,
        user: pick(user, ["id", "name", "email", "roles", "type"]),
    };

    const seller = user.type === 1 ? user : { id: "N/A" };
    payload.seller = pick(seller, ["id", "name", "email", "roles", "timezoneName", "type"]);

    const level = !user || isXolaAdmin(user) ? "log" : "debug";
    const logOptions = { url: window.location.href };
    console[level](payload, logOptions); // TODO: Need to redact API keys

    if (logger) {
        logger.log(payload, logOptions);
        if (flushLogs && "flushLogs" in logger) {
            logger.flushLogs();
        }
    }
};

export const getSumologicSessionId = () => {
    // hack to get sumo session.
    // this may break (not badly, it'll just return null) when sumo-logger updated.
    return (logger as any)?.config?.session ?? null;
};

window.addEventListener("error", (error) => {
    // More info: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    if (!error.message.includes("ResizeObserver")) {
        log("Uncaught error", error);
    }
});
